import { call, put, select } from 'redux-saga/effects';

import { setContracts } from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getContracts() {
  const organizationId = yield select((state) => state.organization.uuid);
  const hasCurrentContractId = yield select(
    (state) => state.organization.currentContractId,
  );

  if (!hasCurrentContractId) {
    yield put(setContracts(null));
    return;
  }
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/contracts/current`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.GET,
  });

  if (success && !error) {
    yield put(setContracts({ ...result }));
  } else {
    yield put(setContracts(null));
  }
}
